import styled from 'styled-components';
import { themeGet, getTextColor, getPaletteColor } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
export const Label = styled(Text)`
  color: ${props => getTextColor('scratched')(props)};
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
`;
export const GuaranteeText = styled(Text)`
  margin-top: 16px;
  line-height: 1.25;
`;
export const Title = styled(Text)`
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  color: ${props => getPaletteColor('text.primary')(props)};
  line-height: 1.25;
`;